import useTranslation from 'next-translate/useTranslation';
import clsx from 'clsx';

// Components
import Icon from '@/components/base/Icon';

// Types
import type { AvailableTaskType } from '@/components/composite/FirstStats/Content';

type TasksSummaryListProps = {
    tasks: AvailableTaskType[];
};

const TasksSummaryList = ({ tasks }: TasksSummaryListProps) => {
    const { t } = useTranslation('commons');

    return (
        <div className="flex flex-col space-y-5">
            {tasks.map((task) => (
                <div key={task.slug} className="flex flex-row items-center space-x-3">
                    <span
                        className={clsx(
                            'flex h-5 w-5 items-center justify-center rounded-full border border-icoGray-300',
                            {
                                'border-icoGray-300': !task.completed_at,
                                'border-icoGreen-200': task.completed_at
                            }
                        )}>
                        {task.completed_at ? (
                            <Icon icon="check" className="text-sm text-icoGreen" />
                        ) : null}
                    </span>
                    <p
                        className={clsx('flex-1 text-sm text-icoGray-400', {
                            'text-icoGreen line-through': task.completed_at
                        })}>
                        {t(`modal_first_stats_status.tasks.${task.slug}.title`)}
                    </p>
                </div>
            ))}
        </div>
    );
};

export default TasksSummaryList;
